import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { environment } from '@environment/environment';
import { RestResponse } from '@models/rest';
import { LocalNavigationMenuGroup } from '@models/navigation/local-navigation-menu-group';

@Injectable({ providedIn: 'root' })
export class ApiLocalNavigationMenuService {
  private readonly baseUrl: string;
  private menu$: Observable<LocalNavigationMenuGroup[]>;

  constructor(private http: HttpClient) {
    this.baseUrl = `${ environment.apiUrlv3 }`;
  }

  public getMenu(): Observable<LocalNavigationMenuGroup[]> {
    if (!this.menu$) {
      this.menu$ = this.http.get<RestResponse>(`${ this.baseUrl }/usuario/menu`).pipe(
        map((response: RestResponse) => this.normalizeMenuGroups(response?.data)),
        shareReplay(1),
        catchError((error) => {
          this.menu$ = null;
          return throwError(() => error);
        })
      );
    }

    return this.menu$;
  }

  public clearMenuCache(): void {
    this.menu$ = null;
  }

  private normalizeMenuGroups(
    data: LocalNavigationMenuGroup | LocalNavigationMenuGroup[] | null | undefined
  ): LocalNavigationMenuGroup[] {
    if (!data) return [];
    return Array.isArray(data) ? data : [ data ];
  }
}
